import { action, props } from 'ts-action';
import { RawSignalState } from '../reducers/raw-signal.reducer';

export const load = action(
  '[Raw Signal] load',
  props<{ rawSignal: RawSignalState }>(),
);
